<div
  class="flex flex-col sm:flex-row items-center sm:items-center gap-4 sm:gap-7 p-4 sm:p-6 bg-secondary-500 rounded-2xl shadow-xl animate-fade-in"
  role="region"
  aria-label="Profile Information"
>
  <!-- Avatar with Edit Button -->
  <div class="relative flex-shrink-0">
    <div class="relative">
      <div
        class="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-gray-300 overflow-hidden ring-4 ring-primary-400/30 transition-all duration-300 hover:ring-warning-500/50 flex items-center justify-center"
      >
        @if (profileStore.avatar()) {
          <img
            [src]="profileStore.avatar()"
            [alt]="profileStore.fullName() || 'Profil'"
            class="w-[70%] h-[70%] object-contain animate-scale-in rounded-full"
            loading="lazy"
          />
        } @else {
          <ng-container [ngSwitch]="profileStore.civility()">
            <!-- Homme -->
            <img
              *ngSwitchCase="'M'"
              src="assets/icons/boy.png"
              [alt]="profileStore.fullName() || 'Profil'"
              class="w-[70%] h-[70%] object-contain animate-scale-in"
              loading="lazy"
            />
            <!-- Femme -->
            <img
              *ngSwitchCase="'F'"
              [src]="currentUser?.avatar"
              [alt]="currentUser?.name || 'Profil'"
              class="w-[70%] h-[70%] object-contain animate-scale-in"
              loading="lazy"
            />
            <!-- Anonyme -->
            <svg
              *ngSwitchDefault
              viewBox="0 0 40 40"
              xmlns="http://www.w3.org/2000/svg"
              class="w-[70%] h-[70%] rounded-full"
            >
              <rect width="40" height="40" fill="#9ca3af" />
              <circle cx="20" cy="15" r="9" fill="white" opacity="0.9" />
              <ellipse cx="20" cy="40" rx="16" ry="12" fill="white" opacity="0.9" />
            </svg>
          </ng-container>
        }
      </div>

      <!-- Edit Button -->
      <button
        type="button"
        class="absolute bottom-0 right-0 w-8 h-8 bg-warning-500 rounded-full flex items-center justify-center hover:bg-warning-600 hover:scale-110 transition-all duration-200 shadow-lg focus:outline-none focus:ring-2 focus:ring-warning-400 focus:ring-offset-2"
        aria-label="Edit profile"
        (click)="openAvatarPicker()"
      >
        <svg class="w-5 h-5" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10.5553 2.95168C11.1142 2.34616 11.3936 2.0434 11.6906 1.8668C12.407 1.44067 13.2893 1.42741 14.0178 1.83184C14.3197 1.99945 14.6077 2.29369 15.1838 2.88217C15.7598 3.47065 16.0479 3.76489 16.2119 4.07329C16.6079 4.81744 16.5949 5.71869 16.1777 6.45062C16.0049 6.75397 15.7085 7.03943 15.1157 7.61035L8.06295 14.4033C6.93966 15.4853 6.378 16.0262 5.67605 16.3004C4.97409 16.5746 4.2024 16.5544 2.65902 16.514L2.44904 16.5086C1.97918 16.4963 1.74425 16.4901 1.60769 16.3351C1.47113 16.1801 1.48977 15.9408 1.52706 15.4622L1.54731 15.2024C1.65226 13.8552 1.70473 13.1817 1.96778 12.5762C2.23083 11.9708 2.68458 11.4792 3.59207 10.496L10.5553 2.95168Z"
            stroke="white"
            stroke-width="1.5"
            stroke-linejoin="round"
          />
          <path d="M9.75 3.0376L15 8.2876" stroke="white" stroke-width="1.5" stroke-linejoin="round" />
          <path
            d="M10.5 16.5376H16.5"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
  </div>

  <!-- User Info -->
  <div class="flex flex-col justify-center gap-1.5 sm:gap-3 text-center sm:text-left flex-1 animate-slide-in-left">
    <h1 class="text-xl m-0 sm:text-2xl lg:text-3xl font-poppins font-medium text-support-100 leading-tight">
      {{ profileStore.fullName() || 'Utilisateur' }}
    </h1>
    <div class="flex flex-col gap-2 sm:gap-3">
      @if (profileStore.profession()) {
        <p class="m-0 text-lg sm:text-xl font-average text-support-100">
          {{ profileStore.profession() }}
        </p>
      }
    </div>
  </div>
</div>
